<script setup lang="ts">
import { computed } from "vue";

interface Props {
  color?: "neutral" | "primary" | "secondary" | "accent";
  headerColor?: "primary" | "secondary" | "accent";
}

const props = withDefaults(defineProps<Props>(), {
  color: "neutral",
  headerColor: "secondary"
});

const colorClass = computed<string>(() => `le-floating-container--${props.color}`);
const headerColorClass = computed<string>(() => `le-floating-container__header--${props.headerColor}`);
</script>

<template>
  <div class="le-floating-container" :class="colorClass">
    <div v-if="$slots.header" class="le-floating-container__header" :class="headerColorClass">
      <slot name="header" />
    </div>

    <slot />
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-floating-container {
  border-radius: 4px;
  box-shadow: @shadows[floating-default];

  &--neutral {
    background-color: @colors[@neutrals][100];
  }

  &--primary {
    background-color: @colors[@primary][200];
  }

  &--secondary {
    background-color: @colors[@secondary][100];
  }

  &--accent {
    background-color: @colors[@accent][200];
  }

  &__header {
    padding: 6px;
    border-radius: 4px 4px 0 0;
    text-align: center;
    .body-text("s", "semi-bold");

    &--primary {
      background-color: @colors[@primary][600];
      box-shadow: inset 0px -1px @colors[@primary][800];
      color: @colors[@neutrals][100];
    }

    &--secondary {
      background: @colors[@secondary][500];
      box-shadow: inset 0px -1px @colors[@secondary][600];
      color: @colors[@secondary][900];
    }

    &--accent {
      background: @colors[@accent][500];
      box-shadow: inset 0px -1px @colors[@accent][700];
      color: @colors[@accent][900];
    }
  }
}
</style>
